import { INVOICE_STATUS } from '../../../InvoicesTable/constants'

export const INVOICE_STATUS_VIEW = {
	[INVOICE_STATUS.PAID]: { className: 'green', icon: 'paidInvoice', label: 'invoices.table.paidInvoice' },
	[INVOICE_STATUS.UNPAID]: { className: 'orange', icon: 'unpaidInvoice', label: 'invoices.table.unpaidInvoice' },
	[INVOICE_STATUS.CANCELED]: { className: 'canceled', icon: null, label: 'invoices.table.canceledInvoice' },
}
